class CtrUspBar extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
    this.mobileBreakpoint = 750;
    this.autoplayBreakpoint = 1200;
    this.desktopBreakpoint = 1200;
    this.viewportState = null;
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    if (typeof Swiper === 'undefined') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    this.buildSwiper();
    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }

  getViewportState() {
    var width = window.innerWidth;
    if (width < this.mobileBreakpoint) return 'mobile';
    if (width < this.autoplayBreakpoint) return 'mid';
    if (width < this.desktopBreakpoint) return 'tablet';
    return 'desktop';
  }

  getAutoplayForViewport(blockCount) {
    var width = window.innerWidth;
    if (width <= this.autoplayBreakpoint) return this.dataset.autoplay === 'true' && blockCount > 1;
    return false;
  }

  buildSwiper() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }

    var viewportState = this.getViewportState();
    var isMobile = viewportState === 'mobile';
    var isMid = viewportState === 'mid';
    var isTablet = viewportState === 'tablet';
    var blockCount = parseInt(this.dataset.blockCount, 10) || 0;
    var shouldAutoplay = this.getAutoplayForViewport(blockCount);
    var shouldLoop = shouldAutoplay && blockCount > 1;
    var isDesktopCentered = viewportState === 'desktop' && blockCount <= 5 && !shouldAutoplay;
    var useFreeMode = shouldAutoplay && shouldLoop;
    var speed = parseInt(this.dataset.speed, 10) || 5000;
    var slidesPerView = isMobile ? 1.5 : (isDesktopCentered ? 'auto' : 5);
    var spaceBetween = 0;

    this.classList.toggle('ctr-usp-bar--desktop-centered', isDesktopCentered);

    this.swiperInstance = new Swiper(this, {
      loop: shouldLoop,
      loopedSlides: shouldLoop ? blockCount : 0,
      loopAdditionalSlides: shouldLoop ? blockCount : 0,
      slidesPerView: slidesPerView,
      centeredSlides: isDesktopCentered,
      spaceBetween: spaceBetween,
      speed: speed,
      freeMode: useFreeMode,
      freeModeMomentum: false,
      allowTouchMove: isMobile || isMid || isTablet || blockCount > 5,
      autoplay: shouldAutoplay && shouldLoop ? {
        delay: 1,
        disableOnInteraction: false
      } : false
    });

    if (shouldAutoplay && shouldLoop && this.swiperInstance.autoplay) {
      this.swiperInstance.autoplay.start();
    }

    this.viewportState = viewportState;
  }

  handleResize() {
    var viewportState = this.getViewportState();
    if (viewportState !== this.viewportState) {
      this.buildSwiper();
      return;
    }

    if (this.swiperInstance) {
      this.swiperInstance.update();
      var blockCount = parseInt(this.dataset.blockCount, 10) || 0;
      if (this.getAutoplayForViewport(blockCount) && this.swiperInstance.autoplay) {
        this.swiperInstance.autoplay.start();
      }
    }
  }
}

customElements.get('ctr-usp-bar') || customElements.define('ctr-usp-bar', CtrUspBar);
